import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {Header, CoverForm} from './App';
import * as serviceWorker from './serviceWorker';
import $ from 'jquery';
ReactDOM.render(<Header />, document.getElementById('header'));
ReactDOM.render(<CoverForm />, document.getElementById('contact'));
document.getElementById("delivery").min = new Date().toISOString().split("T")[0];
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

function filler() {
  $('#company').val('Test');
  $('#name').val('Test');
  $('#phone').val('1234567890');
  $('#email').val('test@test.com');
  $('#quantity').val('2');
  var now = new Date();

  var day = ("0" + now.getDate()).slice(-2);
  var month = ("0" + (now.getMonth() + 1)).slice(-2);

  var today = now.getFullYear()+"-"+(month)+"-"+(day) ;

  $('#date').val(today)
}

//filler();
